/** Time for the width / height spring (stiffness 300, damping 32) to settle, with a margin. */
export const SHRINK_SETTLE_MS = 450;

type Size = { width: number; height: number };

/**
 * Reports the OPEN panel's frame size to the host. A bigger size goes out at once (the frame
 * must be ready before the panel grows); a smaller one (collapse while open) waits for the
 * spring to settle, otherwise the iframe shrinks instantly and clips the still-shrinking panel.
 * `report` returns a cancel function for the pending delayed report.
 */
export function createOpenSizeReporter() {
  let last: Size | null = null;
  return {
    report(next: Size, send: (w: number, h: number) => void): () => void {
      const shrinks = last !== null && (next.width < last.width || next.height < last.height);
      if (!shrinks) {
        last = next;
        send(next.width, next.height);
        return () => {};
      }
      const id = setTimeout(() => {
        last = next;
        send(next.width, next.height);
      }, SHRINK_SETTLE_MS);
      return () => clearTimeout(id);
    },
    /** Panel closed: the next open report is immediate. */
    forget() {
      last = null;
    },
  };
}
